import { useState } from "react";
import type { Strings } from "../i18n/strings";
import type { Lang } from "../lib/types";
import type { LegalKind } from "../content/legal";
import { soundEnabled, setSoundEnabled } from "../lib/sound";
import { bwekPromoVisible, openBwek } from "../lib/bwekPromo";

const LANGS: { id: Lang; label: string; sub?: string }[] = [
  { id: "ko", label: "한국어" },
  { id: "en", label: "English" },
  { id: "ja", label: "日本語" },
];

interface Props {
  t: Strings;
  lang: Lang;
  setLang: (l: Lang) => void;
  onBack: () => void;
  onOpenLegal: (k: LegalKind) => void;
}

export default function Settings({ t, lang, setLang, onBack, onOpenLegal }: Props) {
  const [sound, setSound] = useState(soundEnabled());
  function toggleSound() {
    const next = !sound;
    setSound(next);
    setSoundEnabled(next);
  }

  return (
    <div className="screen settings">
      <div className="topbar">
        <button className="navbtn" onClick={onBack}>
          ← {t.back}
        </button>
        <span />
      </div>

      <div>
        <div className="set-block-label">{t.setLangLabel}</div>
        <div className="set-list">
          {LANGS.map((L) => (
            <div key={L.id} className={`set-radio ${lang === L.id ? "on" : ""}`} onClick={() => setLang(L.id)}>
              <span className="set-radio-label">{L.label}</span>
              {L.id === "ja" && lang === "ja" ? (
                <span className="set-radio-sub">{t.jpLogoNote}</span>
              ) : (
                <span className="radio-dot" />
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="set-row" onClick={toggleSound} style={{ cursor: "pointer" }}>
        <span>{lang === "en" ? "Sound" : lang === "ja" ? "サウンド" : "소리"}</span>
        <span className={`switch ${sound ? "on" : ""}`}>
          <span className="switch-knob" />
        </span>
      </div>

      <div>
        <div className="set-block-label">{t.aboutLabel}</div>
        <div className="about-card">{t.disclaimer}</div>
      </div>

      <p className="set-flavor">“{t.moonFlavor}”</p>

      <div className="set-links">
        <button className="set-link" onClick={() => onOpenLegal("privacy")}>
          {t.setPrivacy}
        </button>
        <button className="set-link" onClick={() => onOpenLegal("terms")}>
          {t.setTerms}
        </button>
      </div>

      {/* Bwek 크로스프로모 — 이용약관 아래. Bwek이 없는 스토어(현재 iOS)에선 숨김. 카피 본문은 달 말투라 고정. */}
      {bwekPromoVisible() && (
        <button className="bwek-promo" onClick={openBwek}>
          <span className="bwek-promo-copy">{t.bwekPromo}</span>
          <span className="bwek-promo-cta">→ Bwek</span>
        </button>
      )}

      <div className="set-foot">
        {t.setNoAcct} · hyuh v{__APP_VERSION__} · {__BUILD_ID__}
      </div>
    </div>
  );
}
